<div class="w-full max-w-3xl mx-auto">
    <h1 class="text-lg lg:text-3xl text-center my-10">Explore Our Branches Across South Africa</h1>

    @for(province of provinces; track province) {
    <div class="border-b border-gray-200">

        <!-- Accordion Header -->
        <button (click)="toggleProvince(province)"
            class="flex justify-between items-center w-full px-4 py-3 text-left text-lg font-semibold text-gray-800 hover:bg-gray-100">
            {{ province.title }}
            <svg class="w-5 h-5 transform transition-transform duration-200" [class.rotate-180]="province.active"
                fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
        </button>

        <!-- Accordion Content -->
        @if (province.active) {
        <div class="px-6 py-4 bg-gray-50 text-sm space-y-4">
            @for (branch of province.branches; track branch) {
            <div class="border rounded-lg p-4 bg-white shadow-sm">
                <h3 class="font-semibold text-gray-900 mb-2">{{ branch.name }}</h3>

                @if (branch.location) {
                <div class="flex items-start gap-2 text-gray-600">
                    <span>📍</span>
                    <p>{{ branch.location }}</p>
                </div>
                }

                @if (branch.address) {
                <div class="flex items-start gap-2 text-gray-600">
                    <span>🗺️</span>
                    <p>{{ branch.address }}</p>
                </div>
                }

                @if (branch.phone) {
                <div class="flex items-start gap-2 text-gray-600">
                    <span>☎</span>
                    <p>{{ branch.phone }}</p>
                </div>
                }

                @if (branch.contactPerson) {
                <div class="flex items-start gap-2 text-gray-600">
                    <span>👤</span>
                    <p>{{ branch.contactPerson }}</p>
                </div>
                }

                @if (branch.email) {
                <div class="flex items-start gap-2 text-gray-600">
                    <span>📧</span>
                    <p>
                        <a href="mailto:{{ branch.email }}" class="text-blue-600 hover:underline">
                            {{ branch.email }}
                        </a>
                    </p>
                </div>
                }

                @if (branch.websiteName) {
                <div class="flex items-start gap-2 text-gray-600">
                    <span>🌐</span>
                    <p>
                        <a [href]="branch.website" target="_blank" class="text-blue-600 hover:underline">
                            {{ branch.websiteName }}
                        </a>
                    </p>
                </div>
                }
            </div>
            }
        </div>
        }

    </div>
    }
</div>